import React from "react";
import { FOOTER_LINKS, HEADER_LINKS } from "../../constants";
import ScrollToTop from "../../components/ScrollToTop";
import { TitleTag } from "../../components/TitleTag";
import Header from "../../components/Header";
import HeroCarousel from "../../components/HeroCarousel";
import Mission from "../../components/Mission";
import ServicesCheckList from "../../components/ServicesCheckList";
import Gallery from "../../components/Gallery";
import Footer from "../../components/Footer";

export const HomePage = () => {
  return (
    <>
      <ScrollToTop />
      <TitleTag pageTitle="Home" />
      <Header dropDownLinks={HEADER_LINKS} />
      <HeroCarousel />
      <Mission />
      <ServicesCheckList />
      <Gallery />
      <Footer footerLinks={FOOTER_LINKS} />
    </>
  );
};
